(() => {
  if (window.__guttifulAccordionAnimateInit) return;
  window.__guttifulAccordionAnimateInit = true;

  const animate = (details, content) => {
    if (details.classList.contains('is-animating')) return;
    details.classList.add('is-animating');
    const isOpen = details.hasAttribute('open');

    if (!isOpen) {
      details.setAttribute('open', '');
      const targetHeight = content.scrollHeight;
      content.style.height = '0px';
      requestAnimationFrame(() => {
        content.style.height = targetHeight + 'px';
      });
      content.addEventListener(
        'transitionend',
        () => {
          content.style.height = '';
          details.classList.remove('is-animating');
        },
        { once: true }
      );
    } else {
      const startHeight = content.scrollHeight;
      content.style.height = startHeight + 'px';
      requestAnimationFrame(() => {
        content.style.height = '0px';
      });
      content.addEventListener(
        'transitionend',
        () => {
          details.removeAttribute('open');
          content.style.height = '';
          details.classList.remove('is-animating');
        },
        { once: true }
      );
    }
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.accordion > details > summary');
    if (!summary) return;
    const details = summary.parentElement;
    const content = summary.nextElementSibling;
    if (!details || !content || !content.classList.contains('accordion__content')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    event.preventDefault();
    animate(details, content);
  });
})();
